var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetupListingsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40347,
    stopColor: "#ff2260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#ff1154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d114d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.25297,
    y: 25.14137,
    width: 15.49399,
    height: 6.76922
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.6236,28.52592v5.26129h-19.24725v-5.26129h-8.70233v46.3327h36.65198V28.52592h-8.70239ZM56.28149,64.22252c-1.92529-.94464-3.09436-3.10266-2.5929-5.23297.1911-.82275,1.23547-2.95581,2.21613-4.96417.91974-1.88098,1.78406-3.65112,1.85052-4.13318.13293-1.02222-.40997-1.10809-.75073-1.12469-.43768-.02216-.784.19116-1.21338.83936-.27148.40723-2.45441,4.73706-3.9115,7.63196-.66211,1.3103-1.17181,2.32697-1.2937,2.55133-.68701,1.29645-1.55133,1.6095-2.4184,1.56244-1.26874-.06653-1.84772-.74524-1.66492-1.96686.04987-.3269.66766-1.83942,1.33527-3.47388.78674-1.93359,1.64825-4.03894,1.72583-4.57635.08868-.61224-.0332-1.26044-.63715-1.57074-.60944-.31299-1.32416.16345-1.54022.52637-.1413.23822-1.11639,2.71759-2.14417,5.33264-1.13574,2.88379-2.33527,5.93103-2.55688,6.3327-.73132,1.33521-1.50421,1.75909-2.66492,1.81445-2.7453.13025-4.78137-2.13025-3.88385-4.89771.07483-.22992.22437-.73688.43213-1.42944.90588-3.03613,2.86163-9.59875,3.95032-11.5379.90033-1.6012,3.40186-2.81451,5.13599-2.06378.56787.24652,1.27704.58447,1.81171.8421.3103.1496.56238.26874.69531.32971.74243.32965,1.53192-.41003,1.95581-.8089.06091-.05542.11353-.10529.1579-.1441.04248-.03693.08398-.07385.12463-.11078.3158-.27704.62885-.55127,1.01392-.71472.43494-.18835,1.11914-.26593,1.64825-.18835.53187.07758.84772.27979,1.04438.43768.3269.26038.54852.47369.82831.74243l.17175.16339c.5097.4848.88647.25488,1.16071.08868l.07202-.04156.01385-.0083c.47369-.27704.85602-.49866,2.26605-.47369,1.46539.0249,3.14972.55127,3.50153,3.04999.18835,1.34906-.87817,3.7287-1.98627,6.20251-1.17456,2.6178-2.39343,5.34094-2.21613,7.04736.12738,1.19952,1.22443,1.35187,2.3103,1.50146,1.03607.14404,2.05829.28534,2.22174,1.3269.43213,2.77026-4.93927,1.73975-6.16925,1.13861Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetupListingsScraper);
export default __webpack_public_path__ + "static/media/meetup-listings-scraper.2e7cb23c9c60e6a53e51698714f84c26.svg";
export { ForwardRef as ReactComponent };